/**
 * SurveyElements - dev-only page for testing/previewing SurveyJS custom elements.
 * Accessible only on localhost via /surveyelements route.
 * 
 * Usage: /surveyelements?surveycode=625
 * Fetches form JSON from the "forms" controller and renders it via the unified SurveyForm.
 */
import { useRef } from 'react';
import { useSearchParams, useParams } from 'react-router-dom';
import SurveyForm from 'ad-web-ui-library';
import { APIGet } from '../components/API/APIRequest';

const SurveyElements = () => {
    const [searchParams] = useSearchParams();
    const { environment } = useParams();
    // Form is addressed by ?surveycode= (inf_SURVEY.SURVEYCODE); still passed to the
    // SurveyForm component via its internal "formId" prop.
    const formId = searchParams.get("surveycode");
    const surveyRef = useRef(null);

    return (
        <div className="container-wrapper inlineforms">
            <section>
                <div className="container">
                    <div className="item-container">
                        <div className="item-wrapper">
                            <h2>Survey Elements</h2> 
                        </div>
                    </div>

                    {formId ? (
                        <div className="item-container">
                            <div className="item-wrapper">
                                <SurveyForm
                                    ref={surveyRef}
                                    formId={formId}
                                    apiGet={APIGet}
                                    environment={environment}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="item-container">
                            <div className="item-wrapper">
                                <p>No surveycode provided. Add <code>?surveycode=625</code> to the URL.</p>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default SurveyElements;
